import { __ } from '../../factories/i18n.js';

[
    <div data-nosnippet>
        <span>{__('rotate your device')}</span>
        <div class="phone"></div>
    </div>,
];
